<template>
  <nuxt-link
    v-if="category.slug"
    class="category-list-item"
    :to="`/${category.slug}/`"
  >
    <div class="category-list-item__text">
      {{ category.title }}
    </div>
    <UiResponsiveImage
      class="category-list-item__image"
      :src="img"
      :alt="category.title"
      :title="category.title"
      draggable="false"
      :adaptive-image="img !== '/static/images/no-img.svg'"
      :mobile-sizes="{ width: 173, height: 96 }"
      :desktop-sizes="{ width: 346, height: 192 }"
    />
  </nuxt-link>
</template>

<script lang="ts" setup>
import type { CatalogListBlockItem } from '~/interfaces/constructor';

const props = defineProps({
  category: {
    type: Object as () => CatalogListBlockItem,
    required: true,
  },
});

const img = computed(() => {
  return (
    props.category?.image_webp ||
    props.category?.image ||
    '/static/images/no-img.svg'
  );
});
</script>
<style scoped lang="scss">
.category-list-item {
  position: relative;
  width: 116px;
  height: 166px;
  //margin-right: 8px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  background: $achromatic-card-bg;

  &:nth-last-of-type(-n + 2) {
    display: none;
    @include xxl-block {
      display: flex;
    }
  }

  @include sm-block {
    width: 138px;
    height: 176px;
  }
  @include md-block {
    width: 100%;
  }
  @include xl-block {
    height: 216px;
  }

  &__text {
    padding: 8px 8px 0;
    width: 100%;
    height: 72px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: anywhere;
    color: $achromatic-black;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    @include sm-block {
      -webkit-line-clamp: 3;
      padding: 12px 12px 0;
      -webkit-hyphens: none;
      -ms-hyphens: none;
      hyphens: none;
    }
    @include xl-block {
      padding: 16px 16px 0;
      height: 60px;
      font-size: 15px;
      line-height: 22px;
    }
  }

  &__image {
    width: 100%;
    height: 86px;
    @include sm-block {
      height: 96px;
    }
    @include xl-block {
      height: 132px;
    }
  }
}
</style>
